import {createSlice} from '@reduxjs/toolkit';
import {checkInStatusesAdapter} from './adapters';
import {
  loadCheckInStatus,
  loadConnectionsCheckInStatus,
  updateCheckInStatus,
  setShouldCheckInAfterWorkspaceReservation,
  updateCheckInStatusNew,
} from './actions';
import {showCheckInBottomSheet} from './actions';
import {getInitialState} from './initialState';

const slice = createSlice({
  name: 'checkIn',
  initialState: getInitialState(),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCheckInStatus.pending, (state) => {
        state.isLoadingUserCheckIn = true;
      })
      .addCase(loadCheckInStatus.fulfilled, (state, action) => {
        state.status = action.payload;
        state.isLoadingUserCheckIn = false;
      })
      .addCase(loadCheckInStatus.rejected, (state) => {
        state.isLoadingUserCheckIn = false;
      })
      .addCase(updateCheckInStatus.pending, (state) => {
        state.isLoadingUserCheckIn = true;
      })
      .addCase(updateCheckInStatus.fulfilled, (state, action) => {
        state.status = action.payload;
        state.isLoadingUserCheckIn = false;
      })
      .addCase(updateCheckInStatus.rejected, (state) => {
        state.isLoadingUserCheckIn = false;
      })
      .addCase(updateCheckInStatusNew.pending, (state) => {
        state.isLoadingUserCheckIn = true;
      })
      .addCase(updateCheckInStatusNew.fulfilled, (state, action) => {
        state.status = action.payload;
        state.isLoadingUserCheckIn = false;
      })
      .addCase(updateCheckInStatusNew.rejected, (state) => {
        state.isLoadingUserCheckIn = false;
      })
      .addCase(setShouldCheckInAfterWorkspaceReservation, (state, action) => {
        state.shouldCheckInAfterWorkspaceReservation = action.payload;
      })
      .addCase(loadConnectionsCheckInStatus.pending, (state) => {
        state.isLoadingConnectionsCheckIn = true;
      })
      .addCase(loadConnectionsCheckInStatus.fulfilled, (state, action) => {
        checkInStatusesAdapter.setAll(state.connectionsCheckInStatus, action.payload ?? []);
        state.isLoadingConnectionsCheckIn = false;
      })
      .addCase(loadConnectionsCheckInStatus.rejected, (state) => {
        state.isLoadingConnectionsCheckIn = false;
      })
      .addCase(showCheckInBottomSheet, (state, action) => {
        state.isCheckInBottomSheetVisible = action.payload;
      });
  },
});

export const {reducer: checkInReducer} = slice;
